import React, { useState } from "react";
import { Box, Collapse } from "@mui/material";

export const Collapsible = ({ children, ...props }) => {
  return <Box {...props}>{children}</Box>;
};

export const CollapsibleTrigger = ({ children, onClick, ...props }) => {
  return (
    <Box
      component="button"
      onClick={onClick}
      sx={{
        background: "none",
        border: "none",
        padding: 0,
        cursor: "pointer",
        width: "100%",
        textAlign: "left",
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const CollapsibleContent = ({ children, open, ...props }) => {
  return (
    <Collapse in={open} {...props}>
      <Box>{children}</Box>
    </Collapse>
  );
};
